module.exports = __webpack_public_path__ + "media/images/guide_dottedline-9d3eabf7bccb2d830ec7ecf3af856903.svg";